import { isPromiseLike, isUnknownDictionary } from "@knyt/artisan";
function hasPromises(value) {
    if (!isUnknownDictionary(value)) {
        return false;
    }
    for (const key in value) {
        const propertyValue = value[key];
        if (isPromiseLike(propertyValue)) {
            return true;
        }
    }
    return false;
}
export function resolvePartialPromise(obj) {
    return hasPromises(obj)
        ? _resolvePartialPromise(obj)
        : obj;
}
/**
 * @internal scope: package
 */
async function _resolvePartialPromise(props) {
    const awaitedRecord = Object.fromEntries(await Promise.all(Object.entries(props).map(async ([key, value]) => {
        let awaitedValue;
        if (isPromiseLike(value)) {
            awaitedValue = await value;
        }
        else {
            awaitedValue = value;
        }
        return [key, awaitedValue];
    })));
    return awaitedRecord;
}
